export default __webpack_public_path__ + "static/media/Group23.1e188ffc.png";